import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ImportJobDto } from '../../../models/user/dto/import-job.dto';

export type CreateImportJobInput = {
  file: File;
  newCohortName?: string;
  existingCohortId?: string;
};

/**
 * Uploads the raw CSV to the async import pipeline (Phase 2). Returns a PENDING
 * ImportJob immediately; poll useGetImportJob for progress. Handles arbitrarily
 * large lists (18K+) without the client parsing or the request timing out.
 */
export const useCreateImportJob = (organizationId: string) => {
  const client = useApiClient();

  return useMutation({
    mutationFn: (input: CreateImportJobInput) => {
      const formData = new FormData();
      formData.append('file', input.file);
      if (input.newCohortName)
        formData.append('newCohortName', input.newCohortName);
      if (input.existingCohortId)
        formData.append('existingCohortId', input.existingCohortId);

      return client.fetchApiWithFormData<ImportJobDto>({
        endpoint: `users/imports?organizationId=${organizationId}`,
        method: 'POST',
        formData,
      });
    },
  });
};
